"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountGroupTimeChart = void 0;
const ChartType_1 = __importDefault(require("@opsbase/lib-chart/ChartType"));
const useDimensions_1 = __importDefault(require("@opsbase/react-hooks/useDimensions"));
const Area3DStacked_1 = __importDefault(require("@opsbase/web-charts/Area3DStacked"));
const Bar3DGrouped_1 = __importDefault(require("@opsbase/web-charts/Bar3DGrouped"));
const Bar3DStacked_1 = __importDefault(require("@opsbase/web-charts/Bar3DStacked"));
const MouseEnterDatumMutation_1 = __importDefault(require("@opsbase/web-charts/helpers/MouseEnterDatumMutation"));
const MouseEnterTickMutation_1 = __importDefault(require("@opsbase/web-charts/helpers/MouseEnterTickMutation"));
const MouseLeaveDatumMutation_1 = __importDefault(require("@opsbase/web-charts/helpers/MouseLeaveDatumMutation"));
const MouseLeaveTickMutation_1 = __importDefault(require("@opsbase/web-charts/helpers/MouseLeaveTickMutation"));
const react_1 = __importStar(require("react"));
const ChartPane_1 = __importDefault(require("../ChartPane"));
const useCountGroupTimeData_1 = __importDefault(require("./useCountGroupTimeData"));
function CountGroupTimeChart({ chart, width, height, fontSize, highlightXId, highlightYId, onClickValue, onClickDimX, }) {
    const { loading, data } = (0, useCountGroupTimeData_1.default)(chart.config.timeDimension, chart.config.otherDimension);
    const [paneRef, paneDims] = (0, useDimensions_1.default)();
    // Handle Datum (Group) clicking
    const onClickDatum = (0, react_1.useCallback)((e, v) => {
        const d = v.datum || v.data[0];
        onClickValue({ v: d.y, x: d.xDim, y: d.yDim });
    }, [onClickValue]);
    const onMouseEnterDatum = (0, react_1.useCallback)(() => MouseEnterDatumMutation_1.default, []);
    const onMouseLeaveDatum = (0, react_1.useCallback)(() => MouseLeaveDatumMutation_1.default, []);
    // Handle Tick (Date) clicking
    const onClickTick = (0, react_1.useCallback)((e, v) => {
        onClickDimX(data[0][v.index].xDim);
    }, [data, onClickDimX]);
    const onMouseEnterTick = (0, react_1.useCallback)(() => MouseEnterTickMutation_1.default, []);
    const onMouseLeaveTick = (0, react_1.useCallback)(() => MouseLeaveTickMutation_1.default, []);
    const chartBit = (0, react_1.useMemo)(() => {
        var _a;
        if (loading || !data || !data.length || !paneDims)
            return null;
        // Handle Highlights
        data.forEach(dd => dd.forEach(d => {
            d.y = !highlightYId || d.yDim.id === highlightYId ? d.yRaw : 0;
            const isInRange = !highlightXId || d.xDim.id === highlightXId;
            const label = d.xDim.label.trim();
            d.opacity = isInRange ? 1 : 0.1;
            d.xDim.label = isInRange ? ' ' + label + ' ' : label;
        }));
        const xLabels = ((_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.map(d => (d.xDim.label + '').split(' - ').join('\n'))) || [];
        let chartProps = Object.assign(Object.assign({ width: paneDims.width, height: paneDims.height, fontSize,
            data,
            xLabels }, (onClickDimX
            ? {
                onClickTick,
                onMouseEnterTick,
                onMouseLeaveTick,
            }
            : {})), (onClickValue
            ? {
                onClickDatum,
                onMouseEnterDatum,
                onMouseLeaveDatum,
            }
            : {}));
        if (chart.chartType === ChartType_1.default.BAR3DGROUP)
            return react_1.default.createElement(Bar3DGrouped_1.default, Object.assign({}, chartProps));
        if (chart.chartType === ChartType_1.default.BAR3DSTACK)
            return react_1.default.createElement(Bar3DStacked_1.default, Object.assign({}, chartProps));
        if (chart.chartType === ChartType_1.default.AREA3DSTACK)
            return react_1.default.createElement(Area3DStacked_1.default, Object.assign({}, chartProps));
    }, [
        loading,
        data,
        paneDims,
        highlightYId,
        highlightXId,
        fontSize,
        onClickDimX,
        onClickTick,
        onMouseEnterTick,
        onMouseLeaveTick,
        onClickValue,
        onClickDatum,
        onMouseEnterDatum,
        onMouseLeaveDatum,
        chart.chartType,
    ]);
    // Done
    return (0, react_1.useMemo)(() => (react_1.default.createElement(ChartPane_1.default, { ref: paneRef, loading: loading, width: width, height: height }, chartBit)), [paneRef, loading, width, height, chartBit]);
}
exports.CountGroupTimeChart = CountGroupTimeChart;
exports.default = CountGroupTimeChart;
